import { render, staticRenderFns } from "./StudentsAddModal.vue?vue&type=template&id=4f687e79&scoped=true&"
import script from "./StudentsAddModal.vue?vue&type=script&lang=js&"
export * from "./StudentsAddModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsAddModal.vue?vue&type=style&index=0&id=4f687e79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f687e79",
  null
  
)

export default component.exports